module.exports = __webpack_public_path__ + "static/media/info-icon.aabd623e.svg";